export const MOFF_CHECK_DATA = {
  // 各年齢.
  'age': ['60〜64', '65〜69', '70〜74', '75〜79', '80〜84', '85〜'],
  // TUG.
  'tug': {
    'male': [
      {'min': 4.97, 'max': 5.67}, {'min': 5.03, 'max': 5.86}, {'min': 5.44, 'max': 6.35},
      {'min': 5.69, 'max': 6.70}, {'min': 5.98, 'max': 7.13}, {'min': 5.98, 'max': 7.13},
    ],
    'female': [
      {'min': 5.31, 'max': 5.89}, {'min': 5.37, 'max': 6.03}, {'min': 5.81, 'max': 6.72},
      {'min': 6.05, 'max': 7.08}, {'min': 5.99, 'max': 7.33}, {'min': 5.99, 'max': 7.33},
    ],
  },
  // 開眼片足立ち.
  'balance': {
    'male': [
      {'min': 28, 'max': 110}, {'min': 21, 'max': 100}, {'min': 13, 'max': 45},
      {'min': 10, 'max': 26}, {'min': 6, 'max': 18}, {'min': 4, 'max': 13},
    ],
    'female': [
      {'min': 29, 'max': 84}, {'min': 18, 'max': 58}, {'min': 11, 'max': 29},
      {'min': 5, 'max': 15}, {'min': 4, 'max': 13}, {'min': 3, 'max': 11},
    ],
  }
};



// WEBPACK FOOTER //
// ./src/common/data/moffcheck_data.tsx